import React from "react";
import { fieldsetStyle, fieldsetTitleStyle } from "./fieldset.css";
import { errorMessageIconStyle, errorMessageStyle } from "./input-base.css";
import { Text } from "@vagastec/ensemble-core";

export function Fieldset({
  children,
  title,
  isValid,
  errorMessage,
  shouldValidate,
  ...rest
}) {
  return (
    <>
      <fieldset className={fieldsetStyle} {...rest}>
        <legend className={fieldsetTitleStyle}>{title}</legend>
        {children}
      </fieldset>
      {!isValid && shouldValidate ? (
        <div className={errorMessageStyle}>
          <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="currentColor"
            className={errorMessageIconStyle}
          >
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793l-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z" />
          </svg>
          <Text size="sm" weight={600} as="p">
            {errorMessage}
          </Text>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
